<template>
  <div class="container">

    <img class="loginTitle" src="../../assets/login_title.png" alt=""/>

    <van-form style="margin-top: 50px;">
        <van-field
          class="inputBg"
          v-model="tel"
          name="手机号"
          placeholder="请输入手机号"
        />  
        <van-field
          style="margin-top: 20px;"
          v-model="phoneCode"
          name="短信验证码"
          placeholder="请输入短信验证码"
        >
          <template #button>
            <div class="codeBtn" @click="sendSMS" :disabled="coding">
              {{ btnText }}
            </div>
           
          </template>
        </van-field>
      </van-form>

      <div
          @click="onSubmit"
          class="btn"
          style="margin-top: 16px"
        >登录</div>

        <img src="../../assets/login_text_btm.png" alt="" style="position: absolute; bottom: 80px; width: 80%; object-fit:contain;"/>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  mounted(){
    if(this.isLogin()){
      this.$router.push({name:'home'})
    }
  },
  data() {
    return {
      tel: "",
      phoneCode: "",
      coding: false,
      btnText: "获取验证码",
      codeTime: 60,
    };
  },
  methods: {
    onSubmit() {
      this.login();
    },

    sendSMS() {
      if (!this.tel || this.coding) {
        return;
      }
      this.$request.GET({
        url: "verification",
        params: { phone: this.tel },
        success: (obj) => {
          this.coding = true;
          Toast("验证码发送成功");
          this.startTimer();
        },
      });
    },

    startTimer() {
      setTimeout(() => {
        this.codeTime--;
        if (this.codeTime <= 0) {
          this.btnText = "发送验证码";
          this.codeTime = 60;
          this.coding = false
        }else{
          this.btnText = this.codeTime+"s后重发"
          this.startTimer();
        }
      }, 1000);
    },

    isLogin(){
      return !!localStorage.getItem("token");
    },

    async login() {
      let self = this;
      self.$request.POST({
              url: "h5/login",
              data: {
                phoneCode: this.phoneCode,
                phone: this.tel,
              },
              success: (obj) => {
                const token = obj.token;
                if (token) {
                  localStorage.setItem("token", token);
                  this.$store.commit("setToken", token);
                  this.$router.push({
                    name: "home",
                  });
                }
              },
            });
    },
  },
};
</script>

<style scoped>
.container {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url("../../assets/editBg.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.column {
  display: flex;
  flex-direction: column;
}
.row {
  display: flex;
  flex-direction: row;
}
.center {
  justify-content: center;
}

.codeBtn{
  height: 50px;
  width: 100px;
  color: white;
  font-weight: 500;
  font-size: 16px;
  line-height: 50px;
}
.hi {
  margin-top: 100px;
  width: 80px;
  height: 40px;
}
.welcome {
  height: 20px;
  align-self: flex-end;
}


.btn {
  width: 340px;
  height: 45px;
  background-color: white;
  border-radius: 10px;
  color:black;
  font-size: 21px;
  text-align: center;
  line-height: 45px;
  font-weight: 500;
}

.loginTitle{
  margin-top: 70px;
  object-fit: contain;
  width: 120px;
}

>>>.van-cell{
  border-radius: 6px;
  background-color: rgba(244, 244, 244, 0.3);;
  width: 340px;
  height: 50px;
  font-size: 16px;
  color: white;
  line-height: 50px;
  padding: 0 16px;
}
>>>.van-field__control {
    display: block;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
    color: white;
    line-height: inherit;
    text-align: left;
    background-color: transparent;
    border: none;
    resize: none;
}

</style>
